/* import __COLOCATED_TEMPLATE__ from './seat-assignment-modal-breakdown-tooltip.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();